<template>
  <div class="page">
    <c-source-page
      :columns="columns"
      :filter="filter"
      :resource="resource"
      :table="table"
      :pagination="pagination"
      exportExcelURL="/orders/export"
    >
      <LogisticsImport />
    </c-source-page>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import createColumns from './columns';
import { ORDER_COLOR_LABEL, SHOP_STATUS } from '@/constants'
import _ from 'lodash';
import LogisticsImport from './logistics-import';

@Component({
  components: {
    LogisticsImport
  }
})
export default class Orders extends Vue {
  @Prop(String) resource;
  table = { data: [] }
  pagination = {}

  get filter() {
    return [
      {
        prop: 'so_id_cont',
        label: '订单编号',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'logistic_l_id_cont',
        label: '快递单号',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'buyer_account_cont',
        label: '买家账号',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'receiver_name_cont',
        label: '收货人姓名',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'receiver_mobile_cont',
        label: '收货人电话',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'user_inviter_key_word_in',
        label: '邀请者名称或编号',
        form: {
          component: 'search'
        }
      },
      {
        prop: 'user_is_employee_eq',
        label: '内部员工订单',
        form: {
          component: 'switch'
        }
      },
      {
        prop: 'order_date_gteq_datetime',
        label: '下单开始时间',
        form: {
          component: 'datePicker'
        }
      },
      {
        prop: 'order_date_lteq_datetime',
        label: '下单结束时间',
        form: {
          component: 'datePicker'
        }
      },
      this.api !== 'lottery_orders' && {
        prop: 'color_label_eq',
        label: '颜色标识',
        form: {
          component: 'select',
          props: {
            options: _.map(ORDER_COLOR_LABEL, (label, value) => ({ label, value })),
          }
        }
      },
      {
        prop: 'shop_status_in',
        label: '订单状态',
        form: {
          component: 'select',
          props: {
            multiple: true,
            options: _.map(SHOP_STATUS, (label, value) => ({ label, value })),
          }
        }
      },
    ].filter(Boolean)
  }

  get columns() {
    return createColumns.call(this, {
      actionColumn: {
        action: ['hide-in-detail']
      },
      resource: this.resource
    });
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get(`/${this.resource}`, { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
